import React, { useContext } from 'react';
import styled from 'styled-components';
import { required } from '@ubeya/shared/utils/form';
import { FlexSpace, FormModal, InputField } from '@ubeya/shared-web/components';
import { responsiveFields } from '@ubeya/shared-web/style';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Container = styled(FlexSpace)`
  ${responsiveFields.mobile};
`;

const DepartmentsModal = ({ selectedDepartment, onClose, onConfirm }) => {
  const { t } = useContext(ConfigContext);

  return (
    <FormModal
      initialValues={selectedDepartment}
      onSubmit={async (values) => {
        await onConfirm(values);
        onClose();
      }}
      size="small"
      onClose={onClose}
      title={selectedDepartment.id ? t('editDepartment') : t('addDepartment')}
      showCancelButton
      disabledOnPristine={false}>
      <Container>
        <InputField name="name" title={t('name')} autoFocus validate={required} />
      </Container>
    </FormModal>
  );
};

export default DepartmentsModal;
